module.exports = __webpack_public_path__ + "static/media/14_l_topol2_0.31_24.07.cdebefdb.png";